export const ConsentsScreenTexts = {
    ContinueButtonLabel: 'Продолжить',
    TryAgainButtonLabel: 'Начать снова',
    PersonalDataErrorMessage: 'Без этого согласия не сможем продолжить',
};
